/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import { formatIpAddrPrefix } from 'ng/shared/utils/ip-prefix-parser.utils';

function subnetListNetworkDataTransformerFactory(
    ListDataTransformer,
) {
    /**
     * @constructor
     * @memberOf module:avi/network
     * @extends module:avi/dataModel.ListDataTransformer
     * @desc
     *
     *     Appending list of subnets to the network name.
     *     Used by {@link module:avi/network.SubnetListNetworkCollection
     *     SubnetListNetworkCollection}.
     */
    class SubnetListNetworkDataTransformer extends ListDataTransformer {
        /** @override */
        processResponse(resp, request) {
            resp = super.processResponse(resp, request);

            const { data } = resp;

            if (data && 'results' in data && Array.isArray(data.results)) {
                data.results.forEach(
                    ({ config }) => SubnetListNetworkDataTransformer.networkTransform(config),
                );
            }

            return resp;
        }

        /**
         * SubnetListNetwork transformer function.
         * @param {Object} network
         */
        static networkTransform(network) {
            network['nameWithSubnets'] = network['name'];

            const { subnet: subnets } = network;

            if (Array.isArray(subnets) && subnets.length) {
                const subnetIds = subnets.map(({ prefix }) => formatIpAddrPrefix(prefix));

                network['nameWithSubnets'] += ` - ${subnetIds.join(', ')}`;
            }
        }
    }

    return SubnetListNetworkDataTransformer;
}

subnetListNetworkDataTransformerFactory.$inject = [
    'ListDataTransformer',
];

angular.module('avi/network')
    .factory('SubnetListNetworkDataTransformer', subnetListNetworkDataTransformerFactory);
